module.exports = __webpack_public_path__ + "assets/pdf/归创通桥数据上报系统-操作手册20251228.dc0acfce.pdf";